import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollabValidationErrorTextPipe } from './collab-validation-error-text.pipe';

@NgModule({
  declarations: [
    CollabValidationErrorTextPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CollabValidationErrorTextPipe
  ]
})
export class CollabValidationErrorTextModule { }
